import { handleActions } from 'redux-actions';
import { Record } from 'immutable';
import {
  USER_SERVICES_LOAD_REQUESTED,
  USER_SERVICES_LOAD_SUCCEEDED,
  USER_SERVICES_LOAD_FAILED,
} from '../actions/userServices';

export const ReducerRecord = Record({
  data: null,
  error: null,
  fetching: false,
});

export default handleActions({
  [USER_SERVICES_LOAD_REQUESTED](state) {
    return state.set('fetching', true);
  },
  [USER_SERVICES_LOAD_SUCCEEDED](state, { payload }) {
    return state
      .set('data', payload)
      .set('fetching', false);
  },
  [USER_SERVICES_LOAD_FAILED](state, { payload }) {
    return state
      .set('data', null)
      .set('error', payload)
      .set('fetching', false);
  },
}, new ReducerRecord());
